import React from "react";
import styles from "./index.module.scss";
import { InputSwitchStateEnum } from "@/types/modular-permissions.types";
import classNames from "classnames";

type Props = {
  inputSwitchState: InputSwitchStateEnum;
  setInputSwitchState: (state: InputSwitchStateEnum) => void;
};

const InputSwitch = ({ inputSwitchState, setInputSwitchState }: Props) => {
  function handleSwitch(inputState: InputSwitchStateEnum) {
    if (inputState === inputSwitchState) return;
    setInputSwitchState(inputState);
  }

  return (
    <div className={styles.switchContainer}>
      <button
        className={classNames(
          inputSwitchState === InputSwitchStateEnum.Wallet && styles.active
        )}
        onClick={() => handleSwitch(InputSwitchStateEnum.Wallet)}>
        {InputSwitchStateEnum.Wallet}
      </button>
      <button
        className={classNames(
          inputSwitchState === InputSwitchStateEnum.Platform && styles.active
        )}
        onClick={() => handleSwitch(InputSwitchStateEnum.Platform)}>
        {InputSwitchStateEnum.Platform}
      </button>
    </div>
  );
};

export default InputSwitch;
